import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';

import { gsap } from 'gsap';

import Header from '../Header';

import { TextPlugin } from "gsap/TextPlugin";
import LockScreen from '../Locker';

gsap.registerPlugin(TextPlugin);





export default function MainPage() {


  const [isUnlocked, setIsUnlocked] = useState(false);

  const handleUnlock = (isCorrect) => {
    if (isCorrect) {
      setIsUnlocked(true);
    } else {
      alert('Incorrect password. Try again.');
    }
  };


  const [query, setQuery] = useState('')


  const [expandMenu, setExpandMenu] = useState(true)


  const [proEnabled, setProEnabled] = useState(false)

  const [queryLaunched, setQueryLaunched] = useState(false)

  const [showResults, setShowResults] = useState(false)
  const [showSources, setShowSources] = useState(false)


  const [resultTitle, setResultTitle] = useState('')
  const [resultText, setResultText] = useState('')
  const [blakeText, setBlakeText] = useState('')
  const [resultSources, setResultSources] = useState([])


  const [step, setStep] = useState(1)



  const performQuery = () => {


    if (query !== '') {

      setQueryLaunched(true)
      // Usage example
      getAnswer(query)
        .then((data) => {
          setQueryLaunched(false)
          setShowResults(true)
          console.log('Server response:', data);
          gsap.fromTo(
            '.steppedContentAppear',
            {
              y: 40,
              opacity: 0
            }, // Start position
            {
              y: 0, // End position
              opacity: 1,
              stagger: 0.15, // Delay between animations
              duration: 0.35, // Duration of each animation
              ease: 'ease.out',
            }
          );

          gsap.from('.mainResultBottomAreaSourcesItemLineCRatingInner', {
            width: 0,
            delay: 1,
            stagger: 0.15, // Delay between animations
            duration: 0.5, // Duration of each animation
            ease: 'ease.out',
          })



        })
        .catch((error) => {
          console.error('Error:', error);
        });
    } else {
      alert('Empty search')
    }








  }




  const openSources = () => {

    setShowSources(prev => !prev)


    if (showSources === false) {
      gsap.fromTo(
        '.mainResultBottomAreaSourcesItem',
        {
          y: 140,
          opacity: 0
        }, // Start position
        {
          y: 0, // End position
          opacity: 1,
          stagger: 0.1, // Delay between animations
          duration: 0.5, // Duration of each animation
          ease: 'power3.out',
        }
      );


      gsap.fromTo(
        '.mainResultBottomAreaSourcesRight',
        {
          y: 140,
          opacity: 0
        }, // Start position
        {
          y: 0, // End position
          opacity: 1,
          delay: 0.25,
          ease: 'power3.out',
        }
      );
    }

  }



  const getAnswer = async (query) => {
    const data = JSON.stringify({ query });

    console.log(data)
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://api.withblake.ai/blake/answer',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    };

    try {
      const response = await axios.request(config);
      setResultTitle(response.data.answer.title)
      setResultText(response.data.answer.answer)
      setBlakeText(response.data.blake.answer)
      setResultSources(response.data.sources)
      console.log(response)
    } catch (error) {
      console.error('Error fetching answer:', error);
      throw error; // Re-throw the error for caller to handle
    }
  };






  return (
    <React.Fragment>
      <div className="App">


        <Header setQuery={setQuery} setShowResults={setShowResults} expandMenu={expandMenu} setExpandMenu={setExpandMenu} />

        {isUnlocked ?    <div className={expandMenu ? 'mainScreen' : 'mainScreen mainScreenExpanded'}>

<div className='mainSearchBoxOuter'>
  {
    queryLaunched && !showResults ? <div className='mainSearchBoxLogoLoading'>

    </div> : null
  }
  <div className={queryLaunched || showResults ? 'mainSearchBoxWrapper mainSearchBoxWrapperCompact' : 'mainSearchBoxWrapper'}>
    <div className={queryLaunched ? 'mainSearchTitle mainSearchTitleTransparent' : 'mainSearchTitle'}>
      Preparing for Cognition
    </div>



    <div className='mainSearchBox'>
      <input value={query} onInput={(event) => setQuery(event.target.value)} className='mainSearchBoxField' autoComplete='off' type='text' name="blakeSearchBox" placeholder='Ask anything...' />


      <div className='mainSearchBoxOptionButton mainSearchBoxOptionButtonFocus'>
        <svg viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0.5H20M3.07692 6.69355L10 6.69355L16.9231 6.69355M6.15385 12.5H12.3077" stroke="#585858" />
        </svg>
        Focus
      </div>

      <div className='mainSearchBoxOptionButton mainSearchBoxOptionButtonAttach'>

        <svg viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 4.19231L9 12.8077M4.69231 8.5L13.3077 8.5M17 8.5C17 12.9183 13.4183 16.5 9 16.5C4.58172 16.5 1 12.9183 1 8.5C1 4.08172 4.58172 0.5 9 0.5C13.4183 0.5 17 4.08172 17 8.5Z" stroke="#585858" />
        </svg>


        Attach
      </div>


      <div onClick={() => performQuery()} className='mainSearchBoxSearchButton'>

        {
          queryLaunched ?


            <svg className='mainSearchBoxSpinner' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M11.9995 2C12.5518 2 12.9995 2.44772 12.9995 3V6C12.9995 6.55228 12.5518 7 11.9995 7C11.4472 7 10.9995 6.55228 10.9995 6V3C10.9995 2.44772 11.4472 2 11.9995 2ZM11.9995 17C12.5518 17 12.9995 17.4477 12.9995 18V21C12.9995 21.5523 12.5518 22 11.9995 22C11.4472 22 10.9995 21.5523 10.9995 21V18C10.9995 17.4477 11.4472 17 11.9995 17ZM20.6597 7C20.9359 7.47829 20.772 8.08988 20.2937 8.36602L17.6956 9.86602C17.2173 10.1422 16.6057 9.97829 16.3296 9.5C16.0535 9.02171 16.2173 8.41012 16.6956 8.13398L19.2937 6.63397C19.772 6.35783 20.3836 6.52171 20.6597 7ZM7.66935 14.5C7.94549 14.9783 7.78161 15.5899 7.30332 15.866L4.70525 17.366C4.22695 17.6422 3.61536 17.4783 3.33922 17C3.06308 16.5217 3.22695 15.9101 3.70525 15.634L6.30332 14.134C6.78161 13.8578 7.3932 14.0217 7.66935 14.5ZM20.6597 17C20.3836 17.4783 19.772 17.6422 19.2937 17.366L16.6956 15.866C16.2173 15.5899 16.0535 14.9783 16.3296 14.5C16.6057 14.0217 17.2173 13.8578 17.6956 14.134L20.2937 15.634C20.772 15.9101 20.9359 16.5217 20.6597 17ZM7.66935 9.5C7.3932 9.97829 6.78161 10.1422 6.30332 9.86602L3.70525 8.36602C3.22695 8.08988 3.06308 7.47829 3.33922 7C3.61536 6.52171 4.22695 6.35783 4.70525 6.63397L7.30332 8.13398C7.78161 8.41012 7.94549 9.02171 7.66935 9.5Z"></path></svg>
            :


            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path></svg>


        }


      </div>




      <div onClick={() => setProEnabled(prev => !prev)} className={proEnabled ? 'mainSearchBoxProSliderWrapper mainSearchBoxProSliderWrapperEnabled' : 'mainSearchBoxProSliderWrapper'}>
        <div className='mainSearchBoxProSlider'>
          <div className='mainSearchBoxProSliderInner'>

          </div>


        </div>
        Pro
      </div>



    </div>




    <br />

    <div className={queryLaunched ? 'searchSuggestions searchSuggestionsTransparent' : 'searchSuggestions'}>

      <div onClick={() => setQuery('How does zkTLS work?')} className='searchSuggestionItem'>
        <div className='searchSuggestionItemIcon searchSuggestionItemIcon1'>

        </div>

        How does zkTLS work?
      </div>


      <div onClick={() => setQuery('List the top revenue generating DEXs')} className='searchSuggestionItem'>
        <div className='searchSuggestionItemIcon searchSuggestionItemIcon2'>

        </div>

        List the top revenue generating DEXs
      </div>

      <div onClick={() => setQuery('Tips for climbing the career ladder')} className='searchSuggestionItem'>
        <div className='searchSuggestionItemIcon searchSuggestionItemIcon3'>

        </div>

        Tips for climbing the career ladder
      </div>


      <div onClick={() => setQuery('Wimbledon 2023 winners')} className='searchSuggestionItem'>
        <div className='searchSuggestionItemIcon searchSuggestionItemIcon4'>

        </div>

        Wimbledon 2023 winners
      </div>




    </div>
  </div>
</div>


<div className={showResults ? 'mainSearchResultOuter' : 'mainSearchResultOuter mainSearchResultOuterTransparent'}>
  <div className='mainSearchResultColumn'>
    <div className='mainSearchResult'>
      <div className='resultQuery'>
        <h1 className='steppedContentAppear'>{resultTitle}</h1>
        <div
          className='steppedContentAppear'
          dangerouslySetInnerHTML={{ __html: resultText }}
        />
         <div
          className='orange'
          dangerouslySetInnerHTML={{ __html: blakeText }}
        />

      </div>

      <div className='resultSources steppedContentAppear'>

        <div className='resultRelatedTitle steppedContentAppear'>
          Sources
        </div>

        {
          resultSources.map((item, index) => {
            return (
              <a target='_blank' href={item.link ? item.link : item.sourceLink} className='mainResultBottomAreaSourcesItem steppedContentAppear'>


                <div className='mainResultBottomAreaSourcesItemLineA'>
                  <div className='mainResultBottomAreaSourcesItemLineAIcon'>
                    {
                      item.link ?

                        item.link.includes('x.com') || item.link.includes('twitter.com') ?


                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M10.4883 14.651L15.25 21H22.25L14.3917 10.5223L20.9308 3H18.2808L13.1643 8.88578L8.75 3H1.75L9.26086 13.0145L2.31915 21H4.96917L10.4883 14.651ZM16.25 19L5.75 5H7.75L18.25 19H16.25Z"></path></svg>


                          :
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9.71002 19.6674C8.74743 17.6259 8.15732 15.3742 8.02731 13H4.06189C4.458 16.1765 6.71639 18.7747 9.71002 19.6674ZM10.0307 13C10.1811 15.4388 10.8778 17.7297 12 19.752C13.1222 17.7297 13.8189 15.4388 13.9693 13H10.0307ZM19.9381 13H15.9727C15.8427 15.3742 15.2526 17.6259 14.29 19.6674C17.2836 18.7747 19.542 16.1765 19.9381 13ZM4.06189 11H8.02731C8.15732 8.62577 8.74743 6.37407 9.71002 4.33256C6.71639 5.22533 4.458 7.8235 4.06189 11ZM10.0307 11H13.9693C13.8189 8.56122 13.1222 6.27025 12 4.24799C10.8778 6.27025 10.1811 8.56122 10.0307 11ZM14.29 4.33256C15.2526 6.37407 15.8427 8.62577 15.9727 11H19.9381C19.542 7.8235 17.2836 5.22533 14.29 4.33256Z"></path></svg>


                        :

                        item.sourceLink.includes('x.com') || item.sourceLink.includes('twitter.com') || item.sourceLink.includes('vxtwitter.com') ?


                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M10.4883 14.651L15.25 21H22.25L14.3917 10.5223L20.9308 3H18.2808L13.1643 8.88578L8.75 3H1.75L9.26086 13.0145L2.31915 21H4.96917L10.4883 14.651ZM16.25 19L5.75 5H7.75L18.25 19H16.25Z"></path></svg>


                          :
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9.71002 19.6674C8.74743 17.6259 8.15732 15.3742 8.02731 13H4.06189C4.458 16.1765 6.71639 18.7747 9.71002 19.6674ZM10.0307 13C10.1811 15.4388 10.8778 17.7297 12 19.752C13.1222 17.7297 13.8189 15.4388 13.9693 13H10.0307ZM19.9381 13H15.9727C15.8427 15.3742 15.2526 17.6259 14.29 19.6674C17.2836 18.7747 19.542 16.1765 19.9381 13ZM4.06189 11H8.02731C8.15732 8.62577 8.74743 6.37407 9.71002 4.33256C6.71639 5.22533 4.458 7.8235 4.06189 11ZM10.0307 11H13.9693C13.8189 8.56122 13.1222 6.27025 12 4.24799C10.8778 6.27025 10.1811 8.56122 10.0307 11ZM14.29 4.33256C15.2526 6.37407 15.8427 8.62577 15.9727 11H19.9381C19.542 7.8235 17.2836 5.22533 14.29 4.33256Z"></path></svg>

                    }
                  </div>
                  <div className='mainResultBottomAreaSourcesItemLineATitle'>


                    {
                      item.link ?
                        item.link.includes('x.com') || item.link.includes('twitter.com') || item.link.includes('vxtwitter.com') ?
                          item.link.match(/https:\/\/(x\.com|twitter\.com|vxtwitter\.com)\/([^\/]+)/)?.[2]
                          :
                          item.link.match(/https:\/\/(www\.)?([^\/]+)/)?.[2]

                        :
                        item.sourceLink.includes('x.com') || item.sourceLink.includes('twitter.com') || item.sourceLink.includes('vxtwitter.com') ?
                          item.sourceLink.match(/https:\/\/(x\.com|twitter\.com|vxtwitter\.com)\/([^\/]+)/)?.[2]
                          :
                          item.sourceLink.match(/https:\/\/(www\.)?([^\/]+)/)?.[2]
                    }
                  </div>
                  <div className='mainResultBottomAreaSourcesItemLineADate'>
                    {/* {new Date(item.date * 1000).toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false }).replace(',', '')} */}
                  </div>
                </div>


                <div className='mainResultBottomAreaSourcesItemLineB'>
                  <div className='mainResultBottomAreaSourcesItemLineBContent'>
                    {item.title}
                  </div>
                </div>


                <div className='mainResultBottomAreaSourcesItemLineC'>

                  {/* <div className='mainResultBottomAreaSourcesItemLineCType'>

                    Rating: {(item.similarityScore*100).toFixed(0)} / 100
                    <div className='mainResultBottomAreaSourcesItemLineCRating'>
                      <div style={{ width: item.similarityScore * 100 + '%' }} className='mainResultBottomAreaSourcesItemLineCRatingInner'>

                      </div>
                    </div>


                  </div> */}


                  <div className='mainResultBottomAreaSourcesItemLineCSource'>

                 {
                  item.link ?
                    item.link.includes('x.com') || item.link.includes('twitter.com') ?
                      <React.Fragment>
                        <div className='mainResultBottomAreaSourcesItemLineCSourceIcon'>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M10.4883 14.651L15.25 21H22.25L14.3917 10.5223L20.9308 3H18.2808L13.1643 8.88578L8.75 3H1.75L9.26086 13.0145L2.31915 21H4.96917L10.4883 14.651ZM16.25 19L5.75 5H7.75L18.25 19H16.25Z"></path></svg>
                        </div>

                        x.com
                      </React.Fragment>
                      :
                      <React.Fragment>
                        <div className='mainResultBottomAreaSourcesItemLineCSourceIcon'>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9.71002 19.6674C8.74743 17.6259 8.15732 15.3742 8.02731 13H4.06189C4.458 16.1765 6.71639 18.7747 9.71002 19.6674ZM10.0307 13C10.1811 15.4388 10.8778 17.7297 12 19.752C13.1222 17.7297 13.8189 15.4388 13.9693 13H10.0307ZM19.9381 13H15.9727C15.8427 15.3742 15.2526 17.6259 14.29 19.6674C17.2836 18.7747 19.542 16.1765 19.9381 13ZM4.06189 11H8.02731C8.15732 8.62577 8.74743 6.37407 9.71002 4.33256C6.71639 5.22533 4.458 7.8235 4.06189 11ZM10.0307 11H13.9693C13.8189 8.56122 13.1222 6.27025 12 4.24799C10.8778 6.27025 10.1811 8.56122 10.0307 11ZM14.29 4.33256C15.2526 6.37407 15.8427 8.62577 15.9727 11H19.9381C19.542 7.8235 17.2836 5.22533 14.29 4.33256Z"></path></svg>
                        </div>

                        Website

                      </React.Fragment>
                  
                  :
                  item.sourceLink.includes('x.com') || item.sourceLink.includes('twitter.com') ?
                  <React.Fragment>
                    <div className='mainResultBottomAreaSourcesItemLineCSourceIcon'>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M10.4883 14.651L15.25 21H22.25L14.3917 10.5223L20.9308 3H18.2808L13.1643 8.88578L8.75 3H1.75L9.26086 13.0145L2.31915 21H4.96917L10.4883 14.651ZM16.25 19L5.75 5H7.75L18.25 19H16.25Z"></path></svg>
                    </div>

                    x.com
                  </React.Fragment>
                  :
                  <React.Fragment>
                    <div className='mainResultBottomAreaSourcesItemLineCSourceIcon'>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM9.71002 19.6674C8.74743 17.6259 8.15732 15.3742 8.02731 13H4.06189C4.458 16.1765 6.71639 18.7747 9.71002 19.6674ZM10.0307 13C10.1811 15.4388 10.8778 17.7297 12 19.752C13.1222 17.7297 13.8189 15.4388 13.9693 13H10.0307ZM19.9381 13H15.9727C15.8427 15.3742 15.2526 17.6259 14.29 19.6674C17.2836 18.7747 19.542 16.1765 19.9381 13ZM4.06189 11H8.02731C8.15732 8.62577 8.74743 6.37407 9.71002 4.33256C6.71639 5.22533 4.458 7.8235 4.06189 11ZM10.0307 11H13.9693C13.8189 8.56122 13.1222 6.27025 12 4.24799C10.8778 6.27025 10.1811 8.56122 10.0307 11ZM14.29 4.33256C15.2526 6.37407 15.8427 8.62577 15.9727 11H19.9381C19.542 7.8235 17.2836 5.22533 14.29 4.33256Z"></path></svg>
                    </div>

                    Website

                  </React.Fragment>
                 }

                  </div>




                </div>
              </a>
            )
          })
        }


      </div>

      <div className='resultRelated'>
        <div className='resultRelatedTitle steppedContentAppear'>
          Related
        </div>
        <div className='resultRelatedGroup steppedContentAppear'>
          <div className='resultRelatedGroupTitle'>
            Protocols
          </div>


          <div onClick={() => showResults()} className='relatedItem'>
            <div className='relatedItemIcon relatedItemIcon1'>

            </div>
            Zama

            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 5H12M12 5L8.68966 1M12 5L8.68966 9" stroke="#CFCFCF" />
            </svg>

          </div>


          <div className='relatedItem'>
            <div className='relatedItemIcon relatedItemIcon2'>

            </div>
            Nillion

            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 5H12M12 5L8.68966 1M12 5L8.68966 9" stroke="#CFCFCF" />
            </svg>

          </div>


          <div className='relatedItem'>
            <div className='relatedItemIcon relatedItemIcon3'>

            </div>
            Zero1 Labs

            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 5H12M12 5L8.68966 1M12 5L8.68966 9" stroke="#CFCFCF" />
            </svg>

          </div>




        </div>

        <div className='resultRelatedGroup steppedContentAppear'>
          <div className='resultRelatedGroupTitle'>
            Core Narratives
          </div>


          <div className='relatedItem'>
            <div className='relatedItemIcon relatedItemIcon4'>

            </div>
            Privasea

            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 5H12M12 5L8.68966 1M12 5L8.68966 9" stroke="#CFCFCF" />
            </svg>

          </div>


          <div className='relatedItem'>
            <div className='relatedItemIcon relatedItemIcon5'>

            </div>
            Fhenix

            <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 5H12M12 5L8.68966 1M12 5L8.68966 9" stroke="#CFCFCF" />
            </svg>

          </div>







        </div>

        <div className='realtedBuy steppedContentAppear'>
          Buy now
        </div>

      </div>



    </div>
  </div>
</div>




</div>
:  <LockScreen onUnlock={handleUnlock} /> }
      


     


      </div>



    </React.Fragment>
  )
}
